import _ from "lodash";
import { createSelector } from "reselect";
import { RootState } from "sweet-web/redux";
import { chat } from "sweet-web/redux/selectors/chat";

const s = (state: RootState) => state.booking;

export const bookings = (state: RootState) => s(state).bookings;

export const editableBooking = (state: RootState) => s(state).editableBooking;

export const editingBooking = (state: RootState) => s(state).editingBooking;

export const isSubmittingProposal = (state: RootState) =>
  s(state).isSubmittingProposal;

export const errorSubmittingProposal = (state: RootState) =>
  s(state).errorSubmittingProposal;

export const isMakingPayment = (state: RootState) => s(state).isMakingPayment;

export const errorMakingPayment = (state: RootState) =>
  s(state).errorMakingPayment;

export const isRevisingBooking = (state: RootState) =>
  s(state).isRevisingBooking;

export const errorRevisingBooking = (state: RootState) =>
  s(state).errorRevisingBooking;

export const getBooking = (bookingId: string) =>
  createSelector(bookings, bookingsValue => {
    return _.get(bookingsValue, bookingId);
  });

export const getBookingByChat = (chatId: string) =>
  createSelector(bookings, bookingsValue => {
    return _.find(bookingsValue, {
      chat: chatId
    });
  });
